<div class="main-container">
  <div class="error-container flex justify-content-center">
    <div
      class="error-form flex flex-column gap-spacing-5xl justify-content-center align-items-center"
    >
      <div
        class="flex flex-column gap-spacing-default justify-content-center align-items-center"
      >
        <span class="text-primary-color error-title">404</span>
        <span class="title-large-bold text-secondary-color text-center">
          Oops! The page you are looking for doesn’t exist.
        </span>
      </div>
      <app-button
        label="Back to homepage"
        sizeClass="p-button-lg"
        severity="primary"
        (onClick)="routeToHome()"
      ></app-button>
    </div>
  </div>
  <div class="image-container background-muted-secondary"></div>
</div>
